import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Modal } from 'antd';
import { initEditorLinkModalData } from '../../../constans/controlToolbar';
import { addLink, editLink } from '../../../utils/changeEditorLinkFns';

const ChangeEditorLinkModalNode = ({ form, linkModal, editor }) => {
  const { getFieldDecorator, validateFieldsAndScroll, resetFields } = form;
  const { editorStateSelector, setEditorState} = editor;
  const { setEditorLinkModalData, editorLinkModalDataSelector} = linkModal;
  
  const dispatch = useDispatch();
  const { visible, url, text, editMode } = useSelector(
    editorLinkModalDataSelector
  );
  const editorState = useSelector(editorStateSelector);

  const handleCancel = () => {
    dispatch(setEditorLinkModalData(initEditorLinkModalData));
    resetFields();
  };

  const handleOk = (e) => {
    e.preventDefault();
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { url, text } = values;

        const textToInsert = text && text.trim() !== '' ? text : url;

        const data = {
          editorState,
          textToInsert,
          url,
        };

        const newEditorState = editMode ? editLink(data) : addLink(data);

        dispatch(setEditorState(newEditorState));

        handleCancel();
      }
    });
  };

  return (
    <Modal visible={visible} onOk={handleOk} onCancel={handleCancel}>
      <Form>
        <Form.Item
          label={editorState.getSelection().isCollapsed() ? 'Текст' : ''}
        >
          {getFieldDecorator('text', {
            initialValue: text || '',
          })(
            <Input
              placeholder="Введите текст ссылки..."
              disabled={!editorState.getSelection().isCollapsed()}
              hidden={!editorState.getSelection().isCollapsed()}
            />
          )}
        </Form.Item>

        <Form.Item label="Ссылка">
          {getFieldDecorator('url', {
            initialValue: url || '',
            rules: [
              { required: true, message: 'Пожалуйста, введите URL.' },
              { type: 'url', message: 'Пожалуйста, введите корректный URL.' },
            ],
          })(<Input placeholder="Введите URL... https://dispex.org" />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ChangeEditorLinkModal = Form.create({ name: 'change_editor_link' })(
  ChangeEditorLinkModalNode
);

export default ChangeEditorLinkModal;
